import { createContext, useContext } from 'react'

/**
 * Where a popover, a menu or a tooltip should be portalled to.
 *
 * `null` — the default — means the body, which is Radix's own default and
 * right for a control on a page.
 *
 * **Inside a dialog or a sheet it must not be the body.** Radix's dialog locks
 * scrolling with `react-remove-scroll`, which cancels every wheel and touch
 * event whose target is outside the dialog's own subtree. A popover portalled
 * to the body *is* outside it, so its content is reachable, clickable, and
 * completely unscrollable — which is how the icon picker ended up showing the
 * first three rows of fifty-eight icons and nothing else, with no way to see
 * the rest.
 *
 * Rather than every popover inside every form remembering to opt out, `Sheet`
 * and `Dialog` publish their own content element here and the portals read it.
 * One fix, and a control does not have to know where it is being used.
 */
export const PortalTargetContext = createContext<HTMLElement | null>(null)

export const usePortalTarget = () => useContext(PortalTargetContext)
